import { type JSX } from "react"
// import { useAppSelector } from "../../app/hooks"
// import { Bird } from "lucide-react"
import type { Result } from "@/utils/types"
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts"
import { type ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart"
import { calculateWPM } from "@/lib/utils"

type ResultsChartProps = {
  results: Result[]
}

const chartConfig = {
  time: {
    label: "Time",
    color: "hsl(var(--chart-1))",
  },
  wpm: {
    label: "Wpm",
    color: "hsl(var(--chart-2))",
  },
} satisfies ChartConfig

export const ResultsChart: React.FC<ResultsChartProps> = ({ results }): JSX.Element | null => {
  return (
    <div className="flex flex-col gap 4 p-4 bg-gray-800 rounded-lg shadow-md">
      <ChartContainer config={chartConfig} className="w-full h-60">
        <LineChart
          accessibilityLayer
          data={results.map((result, index) => {
            return {
              time: index,
              wpm: calculateWPM(result.time_mode, result.char_count, result.language, result.strict_mode),
              language: result.language,
              timeMode: result.time_mode,
              strictMode: result.strict_mode,
            }
          })}
          margin={{
            left: -45,
            right: 12,
            top: 12,
          }}
        >
          <CartesianGrid vertical={true} />
          <XAxis
            dataKey="time"
            tickLine={false}
            axisLine={false}
            //   tickMargin={8}
            //   tickFormatter={value => value.slice(0, 3)}
          />
          <YAxis
            dataKey="wpm"
            tickLine={false}
            axisLine={false}
            //   tickMargin={8}
            //   tickFormatter={value => value.slice(0, 3)}
          />
          <ChartTooltip cursor={true} content={<ChartTooltipContent hideLabel />} />
          <Line
            dataKey="wpm"
            type="natural"
            //   stroke="var(--color-strokes)"
            stroke="white"
            strokeWidth={2}
            dot={{
              // fill: 'var(--color-strokes)',
              fill: "white",
            }}
            activeDot={{
              r: 6,
            }}
          />
        </LineChart>
      </ChartContainer>
    </div>
  )
}
